import React, { Component } from 'react';
import BonusView from 'views/BonusView';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ResizableComponent from 'components/ResizableComponent';
import isMobile from 'utils/isMobile';

class BonusContainer extends ResizableComponent {
  state = { isMobile: isMobile() }
  didResize(w, h, isMobile) {
    if (isMobile !== this.state.isMobile) this.setState({ isMobile });
  }
  render() {
    return <BonusView isMobile={this.state.isMobile} emailState={this.props.emailState} />;
  }
}

function mapStateToProps(state) {
  return {
    emailState: state.applicationState.submitEmail
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BonusContainer);



// WEBPACK FOOTER //
// ./src/containers/BonusContainer.js